import React from "react";
import { BsTrash } from "react-icons/bs";

function DeleteButton({ onclick }) {
  return (
    <button
      onClick={onclick}
      className="text-pink-500 duration-300 ease-in-out hover:text-pink-900 "
    >
      <BsTrash className="w-4 h-4" />
    </button>
  );
}

export default DeleteButton;
